angular.module('admin.statuses', [
  'admin.statuses.index',
  'admin.statuses.detail'
]);


// WEBPACK FOOTER //
// ./client/src/app/admin/statuses/index.js